import React, { Component } from 'react';

import Header from 'components/Header';
import Footer from 'components/Footer';
import ProductItem from 'components/ProductItem';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import * as commonService from 'services/commonService';

class CategoryPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			categoryData: null
		};

		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;

		commonService.onLoadFunction();
	}
	componentDidMount() {
		this.props.setCategoryDataLoader(true);
		this.props.getCategoryData();
	}
	componentDidUpdate() {
		if (!this.state.categoryData && this.props.categoryData) {
			this.setState({ categoryData: this.props.categoryData });
		}
	}
	render() {
		const { loadingCategoryData } = this.state;
		const { categoryData } = this.state;
		return (
			<div className="category-page">
				<Header history={this.props.history} from="category" />

				{loadingCategoryData ? (
					<div className="py-5 text-center">
						<h1 className="py-5">Loading...</h1>
					</div>
				) : (
					<React.Fragment>
						<div className="topSection d-flex flex-row align-items-center my-3 my-md-4 mx-2 mx-sm-2 mx-lg-5">
							<p className="m-0">Home</p>
							<i className="fa fa-chevron-right mx-2 mx-lg-3" />
							<p className="m-0">Vegetables & Fruits</p>
							<i className="fa fa-chevron-right mx-2 mx-lg-3 active" />
							<p className="active m-0">Fruits</p>
						</div>
						<div className="products-list">
							{categoryData &&
							categoryData.results &&
							categoryData.results.length > 0 && (
								<div className="pt-2 pt-md-3 pb-4 pb-md-5 mx-0 mx-sm-2 mx-lg-5">
									<div className="w-100">
										<div className="products row m-0 swiper-wrapper">
											{categoryData.results.map((product, index) => (
												<div className="productItemCont my-2 my-lg-3 px-1 px-lg-2" key={index}>
													<ProductItem item={product} />
												</div>
											))}
										</div>
									</div>
								</div>
							)}
						</div>
					</React.Fragment>
				)}

				<Footer />
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getCategoryData: Actions.getCategoryData,
			setCategoryDataLoader: Actions.setCategoryDataLoader
		},
		dispatch
	);
}
function mapStateToProps(reducer) {
	const homeReducer = reducer.homeReducer;
	return {
		loadingCategoryData: homeReducer.loadingCategoryData,
		categoryData: homeReducer.categoryData
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(CategoryPage);
